var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3622_116377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3622_116377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85807 18.625C8.43628 18.625 8.07763 18.4772 7.78212 18.1817C7.48662 17.8862 7.33887 17.5275 7.33887 17.1058V6.8942C7.33887 6.47242 7.48662 6.11377 7.78212 5.81825C8.07763 5.52275 8.43628 5.375 8.85807 5.375H12.2004C13.2196 5.375 14.1411 5.69231 14.9648 6.32693C15.7885 6.96154 16.2003 7.81603 16.2003 8.89038C16.2003 9.63779 16.0199 10.2471 15.659 10.7183C15.2981 11.1894 14.9093 11.5314 14.4926 11.7442C15.0055 11.9211 15.4952 12.2708 15.9619 12.7933C16.4285 13.3157 16.6619 14.0192 16.6619 14.9038C16.6619 16.182 16.1907 17.1217 15.2484 17.723C14.3061 18.3243 13.3568 18.625 12.4004 18.625H8.85807ZM9.48879 16.6327H12.3196C13.1068 16.6327 13.6632 16.4141 13.9888 15.9769C14.3145 15.5397 14.4773 15.1205 14.4773 14.7192C14.4773 14.3179 14.3145 13.8987 13.9888 13.4615C13.6632 13.0243 13.0914 12.8057 12.2734 12.8057H9.48879V16.6327ZM9.48879 10.875H12.083C12.6907 10.875 13.1725 10.7013 13.5283 10.3539C13.8841 10.0064 14.0619 9.59037 14.0619 9.10575C14.0619 8.59035 13.8738 8.16918 13.4975 7.84225C13.1212 7.51533 12.66 7.35188 12.1138 7.35188H9.48879V10.875Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.c2c5831414213cc5e450858955b44576.svg";
export { ForwardRef as ReactComponent };